import Container from '@repo/ui/container';

import { toClassName } from 'helpers/format';

import { styles } from '.';

type TProps = {
  children: React.ReactNode | any;
  //
  className?: string;
};

const PageBody = (props: TProps) => {
  const { children, className } = props;

  return (
    <div className={toClassName(styles.container, className)}>
      <Container>{children}</Container>
    </div>
  );
};

export default PageBody;
